import {IMessageType} from "../../../../index";
import {_TEntryType} from "../../../../constants/EntryType";

export namespace nsGenerateRsAndMf {

    export enum Step {
        Init,
        Event,
        Recipient,
        Summary,
        Process,
        Finish,
    }

    export enum EventType {
        Add = 1,
        Delete,
        Update,
    }

    type TEventKey = 'add' | 'delete' | 'update'

    export const EventDefinitions: Record<EventType, {type: _TEntryType, key: TEventKey, label: string}> = {
        [EventType.Add]: {
            type: 'AddPermission',
            key: 'add',
            label: `When a user is granted permission`,
        },
        [EventType.Delete]: {
            type: 'DeletePermission',
            key: 'delete',
            label: `When a user loses permission`,
        },
        [EventType.Update]: {
            type: 'EditPermission',
            key: 'update',
            label: `When a user's permission is changed`,
        }
    }

    export enum RecipientType {
        Employee = 1,
        Manager,
        Custom,
        SystemOwner,
    }

    type TRecipientKey = 'user' | 'manager' | 'custom' | 'systemowner'

    export const RecipientDefinitions: Record<RecipientType, {label: string, messageTypeId: IMessageType['id'], key: TRecipientKey}> = {
        [RecipientType.Employee]: {
            label: 'Employee',
            messageTypeId: 4,
            key: 'user',
        },
        [RecipientType.Manager]: {
            label: 'Manager',
            messageTypeId: 3,
            key: 'manager',
        },
        [RecipientType.Custom]: {
            label: 'Custom',
            messageTypeId: 5,
            key: 'custom',
        },
        [RecipientType.SystemOwner]: {
            label: 'System owner',
            messageTypeId: 5,
            key: 'systemowner',
        },
    }

}
